
// eslint-disable-next-line import/no-cycle
import utils from '@/utils';
// eslint-disable-next-line import/no-cycle
import api from '@/api/layout';
import { defineComponent } from 'vue';
import { IUser } from '@/types/models';
import { auth } from '@/store';
import AppMain from './components/AppMain.vue';
import TagsView from './components/TagsView.vue';

interface IState {
  user: IUser;
  isReady: boolean;
}

export default defineComponent({
  name: 'Layout',
  components: {
    AppMain,
    TagsView,
  },
  data() {
    return {
      user: {} as IUser,
      isReady: false,
    } as IState;
  },
  methods: {
    getClassName(list: string) {
      const paths = list.split(',');
      for (const path of paths) {
        if (path === this.$route.fullPath || `${path}/` === this.$route.fullPath) {
          return 'block-item-active';
        }
      }
      return '';
    },

    getAvatarUrl() {
      return utils.getAvatarUrl(this.user);
    },

    btnLinkClick(pageName: string) {
      utils.pageOpen(`/${pageName}`);
    },

    apiGet() {
      api.get((res) => {
        if (res.user) {
          this.user = res.user;

          auth.setUser(this.user);
          utils.loading(false);
          this.isReady = true;
        } else {
          utils.pageOpen('login');
        }
      });
    },
  },
  mounted() {
    this.apiGet();
  },
});
